import './components/header.css';
import './fonts.css';
import './index.css';
import './northdeltastudio-overrides.css';
import './pages/about-page.css';
import './pages/contact-page.css';
import './editorial-system.css';
import './cursors.css';

// Paint the prerendered page before downloading and hydrating the React app.
// Native links remain usable while the interactive bundle loads.
requestAnimationFrame(() => {
  requestAnimationFrame(() => { void import('./bootstrap'); });
});
